import React from "react";
import axios from "./Axios/Default";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./uicons/css/uicons-regular-rounded.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./Store/store";
import Swal from "sweetalert2";
import { Provider } from "react-redux";
import { AUTH_SUCCESS, AUTH_LOGOUT } from "./Store/Action/AuthAction";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

const REFRESH_URL = "v2/refresh";
const LOGIN_URL = "v2/login";

const replaceUrl = (obj) => {
  for (let key in obj) {
    if (Array.isArray(obj[key])) {
      for (let a of obj[key]) {
        replaceUrl(a);
      }
    } else if (typeof obj[key] == "object") {
      replaceUrl(obj[key]);
    } else {
      if (key == "image_name") {
        obj[key] = obj[key].replace("pmc.modena.com", "pmcdev.modena.com");
      }
    }
  }
};

axios.interceptors.response.use(
  (res) => {
    replaceUrl(res);
    return res;
  },
  async (error) => {
    const _orgRequest = error?.config;
    if (error?.response?.status == 401 && !_orgRequest?._retry) {
      _orgRequest._retry = true;
      const refreshToken = localStorage.getItem("refresh_token");
      if (error?.config?.url === REFRESH_URL || error?.config?.url === LOGIN_URL) {
        return Promise.reject(error);
      } else {
        const response = await axios
          .post(REFRESH_URL, { refreshToken })
          .catch((errorRefresh) => {
            store.dispatch({ type: AUTH_LOGOUT });
            return Promise.reject(error);
          });
        if (response && response.status == 200) {
          const { access_token, refresh_token } = response.data;
          const new_access_token = access_token;
          const new_refresh_token = refresh_token;
          const old_access_token = _orgRequest.headers["Authorization"];
          const [header, payload] = old_access_token.split(".");
          const {
            userid,
            fullname,
            position,
            email,
            jobtitle,
            office,
            image_name,
            access,
            role_id,
            nik,
          } = JSON.parse(atob(payload));

          _orgRequest.headers["Authorization"] = `Bearer ${new_access_token}`;
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${new_access_token}`;
          localStorage.setItem("position", position);
          localStorage.setItem("access_token", new_access_token);
          localStorage.setItem("refresh_token", new_refresh_token);
          let tempImageName = localStorage.getItem("image_name");
          if (tempImageName && tempImageName.startsWith("blob:")) {
            localStorage.removeItem("image_name");
            tempImageName = null;
          }
          tempImageName = tempImageName || image_name;
          store.dispatch({
            type: AUTH_SUCCESS,
            userInfo: {
              userid,
              fullname,
              email,
              position,
              jobtitle,
              office,
              image_name: tempImageName,
              access,
              role_id,
              nik,
            },
          });
          return axios(_orgRequest);
        } else {
          return Promise.reject(error);
        }
      }
    } else {
      const code = error?.code;
      if (code == "ERR_NETWORK" || code == "ECONNABORTED") {
        Swal.fire({
          icon: "error",
          title: "Network Error!",
          text: "Request fail, please check your connection!",
        });
      }
      return Promise.reject(error);
    }
  }
);

const access_token = localStorage.getItem("access_token");
if (access_token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
  axios
    .get("v2/admin/user/me")
    .then((res) => {
      if (res && res.status == 200) {
        const [header, payload] = access_token.split(".");
        const {
          userid,
          username,
          fullname,
          email,
          position,
          jobtitle,
          office,
          image_name,
          access,
          role_id,
          nik,
        } = JSON.parse(atob(payload));
        let tempImageName = localStorage.getItem("image_name");
        if (tempImageName && tempImageName.startsWith("blob:")) {
          localStorage.removeItem("image_name");
          tempImageName = null;
        }
        tempImageName = tempImageName || image_name;
        store.dispatch({
          type: AUTH_SUCCESS,
          userInfo: {
            userid,
            username,
            fullname,
            email,
            position,
            jobtitle,
            office,
            image_name: tempImageName,
            access,
            role_id,
            nik,
          },
        });
      }
    })
    .catch((error) => {
      //console.log('Token invalid', error);
      if (!window.location.href.includes("/login")) {
        localStorage.setItem("last_path", window.location.pathname);
        window.location.href = "/login";
      }
    });
}

const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <App />
    </Provider>
  </MsalProvider>
);

reportWebVitals();
